const yearFormatsByTimeZone = new Map();
function yearFormatIn(timeZone) {
    const cached = yearFormatsByTimeZone.get(timeZone);
    if (cached) return cached;
    const format = new Intl.DateTimeFormat('en-US', {
        timeZone,
        year: 'numeric'
    });
    yearFormatsByTimeZone.set(timeZone, format);
    return format;
}
export function calendarYearIn(instant, timeZone) {
    var _yearFormatIn_formatToParts_find;
    const year = (_yearFormatIn_formatToParts_find = yearFormatIn(timeZone).formatToParts(instant).find((part)=>part.type === 'year')) === null || _yearFormatIn_formatToParts_find === void 0 ? void 0 : _yearFormatIn_formatToParts_find.value;
    return Number(year);
}
// should be used from ioContext
export function getTimezoneAbbreviation(date, timeZone) {
    var _navigator, _parts_find;
    const preferred = (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.language;
    const locale = Intl.DateTimeFormat.supportedLocalesOf(preferred)[0] || 'en-US';
    const parts = new Intl.DateTimeFormat(locale, {
        timeZoneName: 'short',
        timeZone
    }).formatToParts(date);
    const tzAbbr = (_parts_find = parts.find((p)=>p.type === 'timeZoneName')) === null || _parts_find === void 0 ? void 0 : _parts_find.value;
    if (!tzAbbr) return null;
    //this regex is to handle the case where the timezone abbreviation is in GMT format
    //in that case i want to convert it to UTC (GMT is the same as UTC just a different name)
    if (/^GMT[+-]/.test(tzAbbr)) {
        return tzAbbr.replace(/^GMT/, 'UTC');
    }
    return tzAbbr;
}
